import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromOrganizationEMRDetails from '@store/reducers/organization-emr-details/organization-emr-details.reducer';

export const selectOrganizationEMRDetailsState = createFeatureSelector<fromOrganizationEMRDetails.State>(
  fromOrganizationEMRDetails.organizationEMRDetailsFeatureKey
);

export const selectIsACO = createSelector(
  selectOrganizationEMRDetailsState,
  (state) => state.isACO
);

export const selectOrgId = createSelector(
  selectOrganizationEMRDetailsState,
  (state: fromOrganizationEMRDetails.State) => state.organizationId
);

export const selectOrganizationEMRForm = createSelector(
  selectOrganizationEMRDetailsState,
  (state: fromOrganizationEMRDetails.State) => ({
    isMemberOfACO: String(state.isACO || 0),
  })
);

// Returns the active EHR's ID (statusID 1000), falling back to first EHR for backward compat
export const selectOrgEMRId = createSelector(
  selectOrganizationEMRDetailsState,
  (state) => {
    const active = state.emrList.find((emr) => emr.statusID === 1000);
    return active?.id ?? state.emrList[0]?.id ?? '';
  }
);
